import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'landing-page';

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  // ✅ PURE MVP: if no hosted landing page asset configured, skip fetching page assets
  const hasLandingAsset = !!config?.appCdnAssets?.landingPage;

  if (!hasLandingAsset) {
    return Promise.resolve();
  }

  // existing Sharetribe behavior continues below
  // return dispatch(fetchPageAssets({ landingPage: config.appCdnAssets.landingPage }, true));
};
